import React, { PureComponent } from 'react'
import { Button, Modal, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import InputCheckboxSlider from '../../../commons/form/InputCheckboxSlider'
import SubscriptionModal from './SubscriptionModal'

class UserSubscriptionsModal extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      showEventModal: false,
      eventSubscription: null,
      eventSubscriptions: []
    }
    this.openEventModal = this.openEventModal.bind(this)
    this.closeEventModal = this.closeEventModal.bind(this)
  }

  openEventModal (eventSubscription) {
    this.setState({ showEventModal: true, eventSubscription })
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal) {
      this.props.actions.fetchEventSubscriptionsFromAdmin(this.props.userId)
      this.props.actions.fetchLowestOrganizedUnits(this.props.userId)
    }
    return null
  }

  componentDidUpdate (prevProps, prevState) {
  }

  componentDidMount () {
  }

  onActiveInputChange (subscriptionId, value) {
    if (value) {
      this.props.actions.enableEventSubscriptionFromAdmin(subscriptionId, this.props.userId)
    } else {
      this.props.actions.disableEventSubscriptionFromAdmin(subscriptionId, this.props.userId)
    }
  }

  getOuColumn (organizedUnits) {
    const ouArray = organizedUnits ? organizedUnits.split(',') : []
    return (<td> {ouArray[0]} {ouArray.length > 1 ? <span className='size10'> (+ {ouArray.length - 1})</span> : '' } </td>)
  }

  closeEventModal () {
    this.setState({ showEventModal: false, eventSubscription: null })
  }

  render () {
    const tKey = 'ADMIN.SUBSCRIPTIONS.'
    const {
      t, userId, defaultLanguageId, eventSubscriptions, showModal,
      combos: { lowestOrganizedUnitsCombo, languages, events },
      actions: { saveEventSubscriptionFromAdmin, removeEventSubscriptionFromAdmin, closeModal, fetchEventsCombo }
    } = this.props
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const subscribedEvents = eventSubscriptions?.map(x => x.notificationEventId) ?? []
    return (
      <Modal id="userSubscriptionsModal" show={showModal} onHide={closeModal} className="_nf eventSubscriptionModal inUserAdmin" backdrop={'static'} >
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className=''>
            <SubscriptionModal
              actions={{
                saveEventSubscriptionFromAdmin,
                closeModal: this.closeEventModal,
                fetchEventsCombo
              }}
              t={t}
              combos={{ lowestOrganizedUnitsCombo, languages, events }}
              showModal={this.state.showEventModal}
              eventSubscription={this.state.eventSubscription}
              subscribedEvents = {subscribedEvents}
              userId = {userId}
              defaultLanguageId = {defaultLanguageId}
            />
            <div>
              <Table hover responsive className="editable-table EventSubscriptionTable">
                <thead>
                  <tr>
                    <th key={'ou'}>{t(`${tKey}OU_COL`)}</th>
                    <th key={'name'}>{t(`${tKey}NAME_COL`)}</th>
                    <th key={'description'}>{t(`${tKey}DESCRIPTION_COL`)}</th>
                    <th className='enabledCol' key={'enabled'}>{t(`${tKey}ENABLE_COL`)}</th>
                    <th className='actionsCol actions' key={'actions'}>{t(`${tKey}ACTIONS_COL`)}</th>
                  </tr>
                </thead>
                <tbody>
                  {eventSubscriptions?.map((subscription, idx) => {
                    return (
                      <tr key={idx} className= { subscription.active ? '' : 'subscriptionDisabled' }>
                        {this.getOuColumn(subscription.organizedUnits)}
                        <td>{subscription.name}</td>
                        <td>{subscription.description}</td>
                        <td className='enabledCol'>
                          <InputCheckboxSlider
                            component={InputCheckboxSlider}
                            colWidth={100} // 25, 33, 50, 75, 100 default=25
                            checked={subscription.active}
                            onInputChange={(value) => this.onActiveInputChange(subscription.subscriptionId, value) }
                          />
                        </td>
                        <td className='actionsCol actions'>
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => this.openEventModal(subscription)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a className='_Btn cancel stk o-icn' onClick={() => removeEventSubscriptionFromAdmin(subscription.subscriptionId, userId)}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
            <div>
              <Button className="_Btn accept"
                onClick={() => this.openEventModal()}>
                <i className="iDocIcon-add-plus"></i>
                {t(`${tKey}ADD_BUTTON`)}
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className='flexInLine al-C'>
          <Button id="okBtn" name="okBtn" className="_Btn accept" onClick={closeModal}>{t('GLOBAL.BUTTONS.OK')}</Button>
          <Button id="cancelBtn" name="cancelBtn" onClick={closeModal} className="_Btn cancel">{t('GLOBAL.BUTTONS.CANCEL')}</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default UserSubscriptionsModal
